import { memo, useCallback } from 'react';

import { sessionAtom, useValue } from '@/store';

import { addEvent } from '@/modules/api';
import { EventType } from '@/modules/models';

import { Button, Icon } from './PromptButton.styles';

interface PromptButtonProps {
  children?: React.ReactNode;
  icon?: string;
  prompt: string;
  disabled?: boolean;
  eventName?: EventType;
}

export const PromptButton = memo<PromptButtonProps>(({ children, icon, prompt, disabled, eventName }) => {
  const session = useValue(sessionAtom);
  const onClick = useCallback(() => {
    window.sayWhattChat.sendNewMessage(prompt);

    if (eventName) {
      addEvent({
        type: eventName,
        userSession: session,
        metadata: {},
      });
    }
  }, [eventName, prompt, session]);

  return (
    <Button disabled={disabled} onClick={onClick}>
      {icon && <Icon src={icon} alt={children?.toString()} />}
      <span>{children}</span>
    </Button>
  );
});
